import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { AnimatePresence, motion } from 'framer-motion';
import { Bar } from 'react-chartjs-2';

import { useChart } from '../hooks';
import { EmployeeAvgYear } from '../type';

ChartJS.register(ChartDataLabels, CategoryScale, LinearScale, BarElement, Legend);

function BarChart({ year }: { year: EmployeeAvgYear }) {
  const { data, options } = useChart({ year });

  return (
    <motion.div
      key={year}
      layout
      initial={{ opacity: 0.8 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}>
      <Bar data={data} options={options} />
    </motion.div>
  );
}

export default BarChart;
